import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=f4f6b4b6&scoped=true"
import script from "./follow.vue?vue&type=script&lang=js"
export * from "./follow.vue?vue&type=script&lang=js"
import style0 from "./follow.vue?vue&type=style&index=0&id=f4f6b4b6&prod&lang=css"
import style1 from "./follow.vue?vue&type=style&index=1&id=f4f6b4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f6b4b6",
  null
  
)

export default component.exports